import axios from "axios";

import api from "./apiService";

import { login as loginToken, getToken } from "./tokenService";
import { setItem, getItem } from "./localStorageService";

const UsuarioService = {
    login: async (email, senha) => {
        let res = await api.post("usuario/auth/token", {
            usuario: email,
            senha: senha,
        });

        let body = res.data;

        loginToken(body.access_token);

        setItem(process.env.REACT_APP_EMAIL_KEY, body.dados_portal.email);
        setItem(process.env.REACT_APP_NOME_KEY, body.dados_portal.nome);
        setItem(process.env.REACT_APP_PERFIL_KEY, body.dados_portal.perfil);
        setItem(process.env.REACT_APP_EMPRESA_KEY, body.dados_portal.empresa);

        if (body.dados_portal.configuracao_portal) {
            setItem(
                process.env.REACT_APP_CONFIG_PORTAL_KEY,
                JSON.stringify(body.dados_portal.configuracao_portal)
            );
        }

        return body.dados_portal;
    },
    buscarTodosPorEmpresa: async () => {
        let res = await api.get("usuario/empresa");
        return res.data;
    },

    cadastrarUsuario: async (user) => {
        try {
            let res = await api.post("usuario/admin", user);
            return res.data;
        } catch (error) {
            return error;
        }
    },

    editarUsuario: async (user) => {
        let res = await api.put("usuario/admin", user);
        return res.data;
    },
    validarToken: async () => {
        try {
            const token = getToken();
            let options = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            await axios.get(
                `${env.REACT_APP_BASE_URL}auth/token/validate`,
                options
            );
            return true;
        } catch (error) {}
        return false;
    },
    getNome: () => getItem(process.env.REACT_APP_NOME_KEY),
    getEmail: () => getItem(process.env.REACT_APP_EMAIL_KEY),
    getPerfil: () => getItem(process.env.REACT_APP_PERFIL_KEY),
    getEmpresa: () => getItem(process.env.REACT_APP_EMPRESA_KEY),
    getConfigPortal: () => {
        try {
            return JSON.parse(getItem(process.env.REACT_APP_CONFIG_PORTAL_KEY));
        } catch (error) {}
        return {};
    },
    redefinirSenha: async (email) => {
        let res = await api.post("usuario/resetar-senha", {
            email: email,
        });
        let body = res.data;
        return body;
    },

    alterarSenha: async (request) => {
        let res = await api.post("usuario/alterar-senha", request);
        return res.data;
    },

    trocarEmpresa: async (empresaID) => {
        const usuarioPerfil = getItem(process.env.REACT_APP_PERFIL_KEY);
        // 1 === ADMIN
        if (usuarioPerfil == 1) {
            await api.patch(`usuario/admin/troca-empresa`, {
                id_empresa: empresaID,
            });
        }
    },
    buscarTodosPorEmpresaId: async (
        empresaId = undefined,
        pagina = 1,
        limite = 10,
        busca = undefined
    ) => {
        const usuarioPerfil = getItem(process.env.REACT_APP_PERFIL_KEY);
        // 1 === ADMIN
        if (usuarioPerfil == 1 && empresaId != undefined) {
            const params = [];

            if (pagina && pagina != "") {
                params.push(`pagina=${pagina}`);
            }

            if (limite && limite != "") {
                params.push(`limite=${limite}`);
            }

            if (busca && busca != "") {
                params.push(`busca=${busca}`);
            }

            const search = params.length > 0 ? `?${params.join("&")}` : "";
            const res = await api.get(
                `usuario/admin/empresa/${empresaId}${search}`
            );

            return {
                usuarios: res.data,
                total: res.headers["x-total-count"],
            };
        }
    },
};

export default UsuarioService;
